import getAssetPath from './env/getAssetPath';


export const productToKeyMap = {
  'imageslider': 'slider',
  'imageslideshow': 'slider',
  'imagecomparison': 'imagecomparison',
  'factbox': 'factbox',
  'timeline': 'timeline',
  'poll': 'poll',
  'polls': 'poll',
  'table': 'table',
  'voting': 'voting',
  'animation': 'animation-tool',
  'quiz': 'p-quiz',
  'personalityquiz': 'personalityquiz',
  'generator': 'simple-generator',
  'graphicimagefilter': 'graphicimagefilter',
  'survey': 'survey',
  'competition': 'competition',
  'imageexpander': 'imageexpander',
  'podcast': 'podcast',
  'toplist': 'toplist'
};

export const envTobucketMap = {
  'local': 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com',
  'dev': 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com', //'https://s3-ap-southeast-2.amazonaws.com/news-networkeditorial',
  'sit': 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com',
  // 'uat': 'https://uat.multitools.newscdn.com.au',
  'uat': 'https://s3-ap-southeast-2.amazonaws.com/uat.multitools.newscdn.com.au',
  'prod': 'https://multitools.newscdn.com.au'
};

export const envToBasePathMap = {
  'local': 'editorialtools',
  'dev': 'editorialtools',
  'sit': 'editorialtools',
  'uat': 'multitools',
  'prod': 'multitools'
};

export const envToAssetPathMap = {
  'local': `//${ window.location.host }:3000/`, // "https://s3-ap-southeast-2.amazonaws.com/news-networkeditorial/editorialtools/build/",
  'dev': 'https://s3-ap-southeast-2.amazonaws.com/news-networkeditorial/editorialtools/build/',
  'sit': 'https://s3-ap-southeast-2.amazonaws.com/news-networkeditorial/editorialtools/build/',
  'uat': 'https://s3-ap-southeast-2.amazonaws.com/uat.multitools.newscdn.com.au/editorialtools/build/',
  'prod': 'https://multitools.newscdn.com.au/editorialtools/build/'
};

// api gateways
// export const environments = new Map([
//   ["local", "http://localhost:4000/"],
//   ["dev", "https://o1zsefrpl5.execute-api.ap-southeast-2.amazonaws.com/dev/"],
//   ["sit", "https://o1zsefrpl5.execute-api.ap-southeast-2.amazonaws.com/dev/"],
//   ["uat", "https://5az2dd7zs7.execute-api.ap-southeast-2.amazonaws.com/uat/"], //TODO: This will need to change to: //"https://uat.multitools.newscdn.com.au/build/",
//   ["prod", "https://indqgewx4e.execute-api.ap-southeast-2.amazonaws.com/prod/"]
// ])

// cloudfront
// export const environments = new Map([
//   // ["local", "https://o1zsefrpl5.execute-api.ap-southeast-2.amazonaws.com/dev/"],
//   // ["local", "https://d1mkfumoam61fz.cloudfront.net/"],
//   ["local", "http://localhost:5000/"],
//   ["dev", "https://d1mkfumoam61fz.cloudfront.net/"],
//   ["sit", "https://d1mkfumoam61fz.cloudfront.net/"],
//   ["uat", "https://d3oetod0ganbku.cloudfront.net/"],
//   ["prod", "https://d3fry4ae33qyp7.cloudfront.net/"]
// ])

// akamai
export const environments = new Map([
  [ 'local', 'http://localhost:5000/' ],
  [ 'dev', 'https://edtools.newssit.com.au' ],
  [ 'sit', 'https://edtools.newssit.com.au' ],
  [ 'uat', 'https://edtools.newsuat.com.au' ],
  [ 'prod', 'https://edtools.news.com.au' ]
]);

export const environmentsUgcCloudFront = new Map([
  [ 'local', 'http://localhost:5000/et-api/ugc/image' ],
  [ 'dev', 'https://d1mkfumoam61fz.cloudfront.net/et-api/ugc/image' ],
  [ 'sit', 'https://d1mkfumoam61fz.cloudfront.net/et-api/ugc/image' ],
  [ 'uat', 'https://d3oetod0ganbku.cloudfront.net/et-api/ugc/image' ],
  [ 'prod', 'https://edtools.news.com.au/et-api/ugc/image' ]
]);

export const environmentsUgcMediaCloudFront = new Map([
  [ 'local', 'http://localhost:5000/et-api/ugc/media' ],
  [ 'dev', 'https://d1mkfumoam61fz.cloudfront.net/et-api/ugc/media' ],
  [ 'sit', 'https://d1mkfumoam61fz.cloudfront.net/et-api/ugc/media' ],
  [ 'uat', 'https://d3oetod0ganbku.cloudfront.net/et-api/ugc/media' ],
  [ 'prod', 'https://edtools.news.com.au/et-api/ugc/media' ]
]);

export const getEnvDetails = (id, type, _env = 'prod') => {
  const env = _env;

  const basePath = envToBasePathMap[env];
  const productKey = productToKeyMap[type] || type;
  const bucket = envTobucketMap[env];
  const ugcImage = environmentsUgcCloudFront.get(env);
  const ugcMedia = environmentsUgcMediaCloudFront.get(env);

  // const assetPath = IS_KURATOR && isLocal ? envToAssetPathMapKurator[env] : envToAssetPathMap[env];
  // const assetPath = IS_KURATOR && isLocal ? `http://localhost:4000/kurator/plugins/k-plugin-editorial-tools/public/` : envToAssetPathMap[env];
  // const embedAssetPath = IS_KURATOR && isLocal ? `http://localhost:4000/kurator/plugins/k-plugin-editorial-tools/public/` : envToAssetPathMap[env];

  const assetPath = getAssetPath(env);
  const api = environments.get(env);

  // console.log('api', env, api)

  return {
    basePath,
    productKey,
    bucket,
    assetPath,
    // embedAssetPath,
    api,
    ugcImage,
    ugcMedia
  };
};
